<app-mens-intimate-wash
  htmlTitle="<strong>Important: Stay Fresh</strong> and Confident During Treatment"
  question="We highly recommend including the Men's Intimate Wash to support comfort and hygiene. Would you like to add it to your order?"
>
  <p class="mb-4">
    Staying on top of your hygiene routine is one of the easiest ways to feel your best—especially while your body is
    focused on recovery. Supporting overall wellness includes maintaining
    <strong>cleanliness in sensitive areas</strong> to help you stay comfortable, fresh, and confident.
  </p>
  <p class="mb-4">
    Our specially formulated <strong>Men's Intimate Wash</strong> is pH-balanced, non-irritating, and designed for daily
    use. It gently cleanses without drying out skin, making it an ideal addition to your wellness plan during treatment.
  </p>
</app-mens-intimate-wash>
